// Common
export const GET_DOWNLOAD_LINK = 'Common/GET_DOWNLOAD_LINK'



// WEBPACK FOOTER //
// ./src/store/mutations_types.js